import LayerPatterns from './LayerPatterns';

export default LayerPatterns;
